import { useEffect, useRef } from "react";

/**
 * Run an async fetch when primitive deps change.
 * Keeps the fetch function in a ref so useCallback identity churn
 * (e.g. profileData object refresh in Redux) cannot retrigger the effect.
 */
export default function useStableFetchEffect(fetchFn, deps, { enabled = true } = {}) {
  const fetchRef = useRef(fetchFn);
  fetchRef.current = fetchFn;
  const generationRef = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;

    const generation = ++generationRef.current;
    let cancelled = false;
    const isStale = () => cancelled || generation !== generationRef.current;

    (async () => {
      await fetchRef.current(isStale);
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);
}
